import { useAppDispatch } from '../grid/reduxStore/Store';
import { useSocketClient } from '../../../providers/SocketContext';
import { useCurrentUser } from '../../../providers/UserProvider';
import { useCheckDocumentLockStatus } from 'components/editor/hooks/useCheckDocumentLockStatus';
import { UndoRedoManagerCommandVersion } from '../UndoRedo/UndoRedoManagerCommandVersion';
import { ContentObjectChangedCommand } from '../UndoRedo/ContentObjectChangedCommand';

export function useNewBlockContentObjectChangedHandler() {
  const dispatch = useAppDispatch();
  const { socketClient } = useSocketClient();
  const { data } = useCurrentUser();
  const checkDocumentLockStatus = useCheckDocumentLockStatus();
  const userId = data.id;

  return async (blockId: string, sectionId: string, oldContent: Record<string, unknown>, newContent: Record<string, unknown>) => {
    const undoRedoManager = UndoRedoManagerCommandVersion.getUndoRedoManager();

    const command = new ContentObjectChangedCommand(blockId, sectionId, oldContent, newContent, {
      dispatch,
      socketClient,
      userId,
      checkDocumentLockStatus,
    });

    const success = await command.redo();

    if (success) {
      undoRedoManager.pushUndoRedoCommands(command);
    }
  };
}
